export enum AUTH_ERROR {
  PROVIDER_FAILED = 'auth.provider_failed',
  PROVIDER_DENIED = 'auth.provider_denied',
  CSRF_CHECK_FAILED = 'auth.csrf_check_failed',
  NO_TOKEN = 'auth.no_token',
}
